export type VidOptConfig = {
	path: string;
	codec: string;
	width?: number;
};

export default ({ path, codec, width }: VidOptConfig): string => {
	if (!path?.startsWith('/content/dam/') || !codec) return path;
	const videoParams = [codec, width, 'webm'].join('.');
	return encodeURI(`/alt/vid-opt/~${videoParams}${path}`);
};
